import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_aa403c54 from 'nuxt_plugin_head_aa403c54' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_2fdbdf40 from 'nuxt_plugin_plugin0_2fdbdf40' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_2fdaf682 from 'nuxt_plugin_plugin1_2fdaf682' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_2fda0dc4 from 'nuxt_plugin_plugin2_2fda0dc4' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_2fd92506 from 'nuxt_plugin_plugin3_2fd92506' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_2fd83c48 from 'nuxt_plugin_plugin4_2fd83c48' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_2fd7538a from 'nuxt_plugin_plugin5_2fd7538a' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_2fd66acc from 'nuxt_plugin_plugin6_2fd66acc' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_2fd5820e from 'nuxt_plugin_plugin7_2fd5820e' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_2fd49950 from 'nuxt_plugin_plugin8_2fd49950' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_2fd3b092 from 'nuxt_plugin_plugin9_2fd3b092' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_1a3e19ff from 'nuxt_plugin_plugin10_1a3e19ff' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_1a3e8e5e from 'nuxt_plugin_plugin11_1a3e8e5e' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_1a3f02bd from 'nuxt_plugin_plugin12_1a3f02bd' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_1a3f771c from 'nuxt_plugin_plugin13_1a3f771c' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_1a3feb7b from 'nuxt_plugin_plugin14_1a3feb7b' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_1a405fda from 'nuxt_plugin_plugin15_1a405fda' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_1a40d439 from 'nuxt_plugin_plugin16_1a40d439' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_1a414898 from 'nuxt_plugin_plugin17_1a414898' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_1a41bcf7 from 'nuxt_plugin_plugin18_1a41bcf7' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_1a423156 from 'nuxt_plugin_plugin19_1a423156' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_1a4c3180 from 'nuxt_plugin_plugin20_1a4c3180' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_1a4ca5df from 'nuxt_plugin_plugin21_1a4ca5df' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_1a4d1a3e from 'nuxt_plugin_plugin22_1a4d1a3e' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_1a4d8e9d from 'nuxt_plugin_plugin23_1a4d8e9d' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_1a4e02fc from 'nuxt_plugin_plugin24_1a4e02fc' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_aa403c54 === 'function') {
    await nuxt_plugin_head_aa403c54(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_2fdbdf40 === 'function') {
    await nuxt_plugin_plugin0_2fdbdf40(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_2fdaf682 === 'function') {
    await nuxt_plugin_plugin1_2fdaf682(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_2fda0dc4 === 'function') {
    await nuxt_plugin_plugin2_2fda0dc4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_2fd92506 === 'function') {
    await nuxt_plugin_plugin3_2fd92506(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_2fd83c48 === 'function') {
    await nuxt_plugin_plugin4_2fd83c48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_2fd7538a === 'function') {
    await nuxt_plugin_plugin5_2fd7538a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_2fd66acc === 'function') {
    await nuxt_plugin_plugin6_2fd66acc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_2fd5820e === 'function') {
    await nuxt_plugin_plugin7_2fd5820e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_2fd49950 === 'function') {
    await nuxt_plugin_plugin8_2fd49950(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_2fd3b092 === 'function') {
    await nuxt_plugin_plugin9_2fd3b092(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_1a3e19ff === 'function') {
    await nuxt_plugin_plugin10_1a3e19ff(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_1a3e8e5e === 'function') {
    await nuxt_plugin_plugin11_1a3e8e5e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_1a3f02bd === 'function') {
    await nuxt_plugin_plugin12_1a3f02bd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_1a3f771c === 'function') {
    await nuxt_plugin_plugin13_1a3f771c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_1a3feb7b === 'function') {
    await nuxt_plugin_plugin14_1a3feb7b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_1a405fda === 'function') {
    await nuxt_plugin_plugin15_1a405fda(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_1a40d439 === 'function') {
    await nuxt_plugin_plugin16_1a40d439(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_1a414898 === 'function') {
    await nuxt_plugin_plugin17_1a414898(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_1a41bcf7 === 'function') {
    await nuxt_plugin_plugin18_1a41bcf7(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_1a423156 === 'function') {
    await nuxt_plugin_plugin19_1a423156(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_1a4c3180 === 'function') {
    await nuxt_plugin_plugin20_1a4c3180(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_1a4ca5df === 'function') {
    await nuxt_plugin_plugin21_1a4ca5df(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_1a4d1a3e === 'function') {
    await nuxt_plugin_plugin22_1a4d1a3e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_1a4d8e9d === 'function') {
    await nuxt_plugin_plugin23_1a4d8e9d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_1a4e02fc === 'function') {
    await nuxt_plugin_plugin24_1a4e02fc(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
